<template>
    <div class="grid-img">
        <div class="wrapper">
            <div class="wrapper__img">
              <img src="@/assets/SoMe.jpg">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'grid-img',
    }
</script>

<style lang="scss" scoped>
    .grid-img {
        height: 100%;
        width: 100%;
        padding: 5% 0;

    }
    .wrapper {
        padding: 0 20%;
        margin: 0 5%;
        text-align: center;
        background-color: #F9FAFB;

           img {
               height: auto;
               width: 100%;
           }

        /* making img full width, possible adding some space*/
        @media screen and (max-width: 768px) {
            padding: 0;
            margin: 0;
        }

    }
</style>